// removed by extract-text-webpack-plugin
module.exports = {"clearfix":"style__clearfix___2xzGh","checkbox":"style__checkbox___Pwy_m"};


//////////////////
// WEBPACK FOOTER
// ./components/FancyCheckbox/style.scss
// module id = 1230
// module chunks = 0